/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./video-duration.vue?vue&type=template&id=31f0cdeb&scoped=true&"
import script from "./video-duration.vue?vue&type=script&lang=ts&"
export * from "./video-duration.vue?vue&type=script&lang=ts&"
import style0 from "./video-duration.vue?vue&type=style&index=0&id=31f0cdeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0cdeb",
  null
  
)

export default component.exports